import React, { forwardRef } from "react";
import logo from "../../Assets/logo/logo_2x.png";
import axislogo from "../../Assets/logo/Axis_Bank_logo.png";

const EasyPayDepositSlip = forwardRef((props, ref) => {
  const { data, copyType, easyPayPaymentCreated } = props;
  const transactionDate = easyPayPaymentCreated?.transactionDate?.split(" ")[0]
  return (
    <div ref={ref} className="easypay-container">
      {/* Header Logos and Title */}
      <div className="easypay-header">
        <img src={axislogo} alt="Axis Bank" className="easypay-axislogo" />
        <div className="text-bold" style={{ fontSize: "15px" }}>
          {copyType} Copy
        </div>
        <img src={logo} alt="Bharti" className="easypay-bhartilogo" />
      </div>

      <div className="easypay-title">EASYPAY DEPOSIT SLIP</div>
      <div className="easypay-subtitle">
        Bharti LIFE INSURANCE CO. LTD. – FIRST & RENEWAL PREMIUM
      </div>
      <div className="easypay-date">Deposition Date: {transactionDate}</div>

      <table className="easypay-table" border="1">
        <tbody>
          <tr>
            <td className="easypay-cell">Premium Payment Type*</td>
            <td className="easypay-cell" style={{ width: "35%" }}>
              <div className="premium-cell">
                <input
                  type="checkbox"
                  defaultChecked
                  readOnly
                  style={{ margin: "0" }}
                />{" "}
                <label>First Premium</label>
              </div>
            </td>
            <td colSpan={3} className="easypay-cell" style={{ width: "35%" }}>
              <div className="premium-cell">
                <input type="checkbox" readOnly style={{ margin: "0" }} />{" "}
                <label>Renewal Premium</label>
              </div>
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Policy No.*</td>
            <td className="easypay-cell">{data?.proposalNo}</td>
          </tr>
          <tr>
            <td className="easypay-cell">Lead Id*</td>
            <td colSpan={3} className="easypay-cell">
              {data?.leadId}
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Policy Holder/Application Name* </td>
            <td colSpan={3} className="easypay-cell">
              {data?.customerName}
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Depositor Name*</td>
            <td colSpan={3} className="easypay-cell">
              {data?.customerName}
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Mobile No. of Depositor*</td>
            <td colSpan={3} className="easypay-cell">
              {data?.mobileNo}
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Amount Payable:*</td>
            <td colSpan={3} className="easypay-cell">
              {easyPayPaymentCreated?.txAmount}
            </td>
          </tr>
          <tr>
            <td className="easypay-cell">Account No.*</td>
            <td colSpan={3} className="easypay-cell">
              {easyPayPaymentCreated?.accountNum || easyPayPaymentCreated?.bancaAccountNum}
            </td>
          </tr>
          <tr>
            <td colSpan={4} className="easypay-cell text-center text-bold">
              All the fields * marked are mandatory
            </td>
          </tr>
          <tr>
            <td colSpan={1} className="easypay-cell">
              Depositor's Signature*
            </td>
            <td colSpan={3} className="easypay-cell">
              <span className="signature-line"></span>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="easypay-table" border="">
        <tbody>
          <tr>
            <td colSpan={4} className="text-center text-bold easypay-cell">
              For Bank use
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="easypay-cell" width="64%">
              Branch Name: ____________________
            </td>
            <td colSpan={2} className="easypay-cell">
              Branch Sol Id: ____________________
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="easypay-cell">
              Transaction No: ____________________
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="easypay-cell">
              Cashier Signatures/Stamp
            </td>
            <td className="easypay-cell">Amount (in Rs.) ___________</td>
          </tr>
        </tbody>
      </table>

      <div className="easypay-note">
        Note: To be accepted at the all Axis Bank Branch
      </div>
    </div>
  );
});

export default EasyPayDepositSlip;
